/**
 * @generated SignedSource<<1521d2bf7736f7297597d44db9eb2c95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Integration_HubspotInfo_Query$variables = Record<PropertyKey, never>;
export type Integration_HubspotInfo_Query$data = {
  readonly hsInfo: {
    readonly allowedContactProperties: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly contactProperties: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly defaultOwner: {
      readonly email: string | null | undefined;
      readonly first_name: string | null | undefined;
      readonly id: string | null | undefined;
      readonly last_name: string | null | undefined;
    } | null | undefined;
    readonly isValidToken: boolean | null | undefined;
    readonly owners: ReadonlyArray<{
      readonly email: string | null | undefined;
      readonly first_name: string | null | undefined;
      readonly id: string | null | undefined;
      readonly last_name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly scopes: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Integration_HubspotInfo_Query = {
  response: Integration_HubspotInfo_Query$data;
  variables: Integration_HubspotInfo_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "first_name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "last_name",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HsInfo",
    "kind": "LinkedField",
    "name": "hsInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValidToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HubspotOwnerType",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": (v0/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HubspotOwnerType",
        "kind": "LinkedField",
        "name": "defaultOwner",
        "plural": false,
        "selections": (v0/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JSONKeyValue",
        "kind": "LinkedField",
        "name": "allowedContactProperties",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JSONKeyValue",
        "kind": "LinkedField",
        "name": "contactProperties",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scopes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_HubspotInfo_Query",
    "selections": (v2/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Integration_HubspotInfo_Query",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d2d22a8b6d12ad76b5e39db9936184dd",
    "id": null,
    "metadata": {},
    "name": "Integration_HubspotInfo_Query",
    "operationKind": "query",
    "text": "query Integration_HubspotInfo_Query {\n  hsInfo {\n    isValidToken\n    owners {\n      id\n      email\n      first_name\n      last_name\n    }\n    defaultOwner {\n      id\n      email\n      first_name\n      last_name\n    }\n    allowedContactProperties {\n      key\n      value\n    }\n    contactProperties {\n      key\n      value\n    }\n    scopes\n  }\n}\n"
  }
};
})();

(node as any).hash = "44421190bcc344e8b8399658cc9463f8";

export default node;
